export default [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
        meta: {
            title: 'Inloggen',
            requiresAuth: false,
        }
    },
    {
        path: '/invite/:token',
        name: 'setPassword',
        component: () => import(/* webpackChunkName: "setPassword" */ '@/views/auth/SetPassword.vue'),
        meta: {
            title: 'Wachtwoord instellen',
            requiresAuth: false,
        }
    },
    {
        name: 'forgotPassword',
        path: '/forgot-password',
        component: () => import(/* webpackChunkName: "ForgotPassword" */ '@/views/auth/ForgotPassword.vue'),
        meta: {
            title: 'Wachtwoord vergeten',
            requiresAuth: false,
        }
    },
    {
        name: 'resetPassword',
        path: '/reset-password/:token/:email',
        component: () => import(/* webpackChunkName: "ResetPassword" */ '@/views/auth/ResetPassword.vue'),
        meta: {
            title: 'Wachtwoord resetten',
            requiresAuth: false,
        }
    },
    {
        name: 'myAccount',
        path: '/my-account',
        component: () => import(/* webpackChunkName: "MyAccount" */ '@/views/auth/MyAccount.vue'),
        meta: {
            title: 'Mijn account',
            requiresAuth: true,
        }
    }
];